import './index.sass';
import './jobs_works';
import initJobCard from './job-card';
import axios from "axios";
import Cookies from "js-cookie";

export default () => {
  const $root = $('.jobs');
  const $btn = $('.js-load-jobs');

  $btn.on('click', function (e) {
    e.preventDefault();
    const $el = $(this);
    initAjax($el);
  });

  const initAjax = ($el) => {
    if(!$el.data('url')) $el.hide();
    $root.find('.jobs__list').append('<div class="list-loader"></div>');
    axios.get($el.data('url'), {
      headers: { 'Accept': 'application/json' }
    }).then((response) => {
      const resp = response;
      const $feeds = $(resp.data.jobs);
      const url = resp.data.url;
      if(url) {
        $el.data('url', url);
      } else {
        $el.remove();
      }
      $root.find('.jobs__list').append($feeds);
      $root.find('.list-loader').remove();
      if(resp.data.pagination) {
        $root.find('.jobs__pagination').html(resp.data.pagination);
      }
    }).catch((error) => {
      console.log(error.response)
    });
  }

  const initWelcomeCustomerPopup = () => {
    $.magnificPopup.open( {
      items: {
        src: '#welcome-customer-popup'
      },
      mainClass: 'mfp-welcome-customer',
      type: 'inline',
      closeBtnInside: true,
      closeOnBgClick: true,
      callbacks: {
        close: function () {
          Cookies.set('welcome_customer_popup_shown', true);
        }
      }
    });
  }

  $('#welcome-customer-popup').length && initWelcomeCustomerPopup();

  initJobCard();
  if ($('.job-card').length) {
    $('.job-banner').insertAfter($('.job-card')[0])
  }
}
